<template>
<div>
    <el-table @sort-change='tableSortChange'  :data="list" border  class="el_table tab_main"  v-loading="loading" stripe empty-text="暂无数据" 

  >
     <el-table-column
      type="index"
      label='序号'
      :index="changeIndex"
      width="50">
    </el-table-column>
    <template v-for="colConfig in colConfigs">
      <slot v-if="colConfig.slot" :name="colConfig.slot"/>
      <el-table-column v-bind="colConfig" v-if="colConfig.prop==='图片预览'?false:true"></el-table-column>
      <el-table-column v-bind="colConfig"   v-if="colConfig.prop==='图片预览'" >
        <template scope="scope">
        　　<img :src=" scope.row.图片预览" width="100" height="100" class="head_pic" />
        </template>
    </el-table-column>
    </template> 
    
  </el-table>
  
</div>
</template>


<script>
export default {
  props: ['colConfigs', 'listdata','page','pagesize'],
  data () {
      return {
          list:'',
          loading:false,
          path:''
      }
  },
   watch:{   // 使用监听的方式，监听数据的变化
      listdata(val){
        this.loading =true
        // const loading = this.$loading({
        //   lock: true,
        //   body:true,
        //   fullscreen:false,
        //   target:'.el_table',
        //   text: 'Loading',
        //   spinner: 'el-icon-loading',
        //   background: 'rgba(255, 255, 255, 255.7)'
        // });
        if(val.length || val != this.list){
            console.log('改变',val)
           setTimeout(() => {
          // loading.close();
  
           this.loading = false
        }, 500);
            this.list = val;
        } else{
          this.list = []
           this.loading = false
        }
       
      }
    },
  methods: {
    changeIndex(index){
      console.log(this.page,'他爸爸发巴萨撒多少啊但是啊',index)
     if( this.page === null || this.page === undefined || this.page === '' || this.page <= 1){
        console.log('出来啊！')
      return index+1;
     
     }else{
        console.log(this.page, '你走的这里吗！', index)
       return this.page*this.pagesize-this.pagesize+index+1
     }
     
    },
    tableSortChange(sort){
      this.$emit('selectShopName', sort)
      console.log(sort)
    }
  },
created () {
    this.list = ''
    this.path = this.$route.path
},
  mounted () {
      // eslint-disable-next-line no-console
      console.log(this.colConfigs) 
       // eslint-disable-next-line no-console
       console.log(this.listdata)
     
  }
}

</script>
<style lang="scss" scoped>
.tab_main{
  margin: 0 auto;
}
</style>
